import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteAnaliseMercadoLancamento } from '../cliente-analise-mercado-lancamento';
import { ClienteAnaliseMercadoLancamentoCreate } from '../create';
import { ClienteAnaliseMercadoLancamentoSave } from '../cliente-analise-mercado-lancamento-save';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoLancamentoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clienteanalisemercado/lancamento`;
    }

    /** Carrega o lançamento da análise de mercado */
    load(perspectiva: number, idCliente: number, ano: number, idClienteAnaliseMercadoClassificacao: number, idGrupoClassificacao: number, idsClassificacoes: number[], criarSeNaoEncontrar = false): Observable<ClienteAnaliseMercadoLancamento> {
        // Params
        let params = new HttpParams()
                            .append('perspectiva', perspectiva ? perspectiva.toString() : null)
                            .append('idCliente', idCliente ? idCliente.toString() : null)
                            .append('ano', ano ? ano.toString() : null)
                            .append('idClienteAnaliseMercadoClassificacao', idClienteAnaliseMercadoClassificacao ? idClienteAnaliseMercadoClassificacao.toString() : null)
                            .append('idGrupoClassificacao', idGrupoClassificacao ? idGrupoClassificacao.toString() : null)
                            .append('criarSeNaoEncontrar', criarSeNaoEncontrar ? criarSeNaoEncontrar.toString() : null);
        // Classificações
        idsClassificacoes?.forEach(idClassificacao => params = params.append('idClassificacao', idClassificacao.toString()));

        return this.customHttp.get<ClienteAnaliseMercadoLancamento>(this.pathApi, {params});
    }

    /** cria o lançamento da análise de mercado do cliente */
    create(entityCreate: ClienteAnaliseMercadoLancamentoCreate): Observable<ClienteAnaliseMercadoLancamento> {
        return this.customHttp.post<ClienteAnaliseMercadoLancamento>(this.pathApi, entityCreate);
    }

    /** Salva o lançamento da análise de mercado */
    save(entitySave: ClienteAnaliseMercadoLancamentoSave): Observable<string> {
        return this.customHttp.put<string>(this.pathApi, entitySave);
    }

    /** exclui o lançamento da classificação na análise de mercado */
    deleteClassificacao(idClienteAnaliseMercadoClassficiacao: number): Observable<string> {
        return this.customHttp.delete<string>(`${this.pathApi}/classificacao/${idClienteAnaliseMercadoClassficiacao}`);
    }
}
